<template>
  <FormLayout
    :is-loading="props.isLoading ?? false"
    title="Location not found."
    overline="Error"
    @on-dismiss="handleDismiss"
  />
</template>

<script setup lang="ts">
import FormLayout from '../common/FormLayout.vue'

const props = defineProps<{
  isLoading?: boolean
}>()
const emit = defineEmits(['dismiss'])
function handleDismiss() {
  emit('dismiss')
}
</script>

<style>
.description {
  margin-top: calc(-1 * var(--space-base));
  margin-bottom: var(--space-small);
}
</style>
